// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Resetting body margin and padding */
body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
}

/* Main app container */
.app {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative; /* Add this to handle absolute positioned children */
}

/* Content area */
.content {
  flex: 1 1;
  padding: 20px;
  background-color: #121212;
  color: #fff;
  overflow-y: auto;
  padding-top: 60px; /* Add padding to account for logout button */
}

/* Title styles */
h1 {
  text-align: center;
  font-size: 24px;
  margin: 0;
  border-bottom: 1px solid #555;
  padding-bottom: 10px;
}

/* Collection title styles */
.collection-title {
  margin-top: 20px;
  font-size: 20px;
}

/* Additional reset for components */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Logout button hover effect */
button:hover {
  background-color: #333 !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB,EAAE,oDAAoD;AAC1E;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,iBAAiB,EAAE,6CAA6C;AAClE;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,iCAAiC;AACnC","sourcesContent":["/* Resetting body margin and padding */\nbody,\nhtml {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\n/* Main app container */\n.app {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  position: relative; /* Add this to handle absolute positioned children */\n}\n\n/* Content area */\n.content {\n  flex: 1;\n  padding: 20px;\n  background-color: #121212;\n  color: #fff;\n  overflow-y: auto;\n  padding-top: 60px; /* Add padding to account for logout button */\n}\n\n/* Title styles */\nh1 {\n  text-align: center;\n  font-size: 24px;\n  margin: 0;\n  border-bottom: 1px solid #555;\n  padding-bottom: 10px;\n}\n\n/* Collection title styles */\n.collection-title {\n  margin-top: 20px;\n  font-size: 20px;\n}\n\n/* Additional reset for components */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* Logout button hover effect */\nbutton:hover {\n  background-color: #333 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
